const type = 'TOGGLE_HD_FILTER'
const toggle = () => ({ type })
const reducer = (state = false, action) => action.type === type ? toggleState(state) : state

const toggleState = state => !state
const selected = state => state

const hdFilterState = { selected: selected, toggle: toggle, reducer: reducer }
export default hdFilterState
